import { render } from "./ScheduledCampaignsTable.vue?vue&type=template&id=6e4d5550"
import script from "./ScheduledCampaignsTable.vue?vue&type=script&lang=js"
export * from "./ScheduledCampaignsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Teh/Dev/web/loop-client-dashboard/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__